import type { ComponentProps } from "react"
import { cn } from "@/lib/utils.js"

/**
 * A bordered block for the few things that need an edge — a form, a
 * manipulable object. It does not float: no shadow at rest. Most content is a
 * `Section` — a heading and whitespace — not a box.
 */
export function Card({ className, ...props }: ComponentProps<"section">) {
  return (
    <section
      className={cn("rounded-lg border bg-card text-card-foreground shadow-xs", className)}
      {...props}
    />
  )
}

export function CardHeader({ className, ...props }: ComponentProps<"header">) {
  return <header className={cn("flex flex-col gap-1 border-b px-4 py-3", className)} {...props} />
}

export function CardTitle({ className, ...props }: ComponentProps<"h3">) {
  return <h3 className={cn("text-[15px] font-semibold text-foreground", className)} {...props} />
}

export function CardDescription({ className, ...props }: ComponentProps<"p">) {
  return <p className={cn("text-[13px] text-muted-foreground", className)} {...props} />
}

export function CardBody({ className, ...props }: ComponentProps<"div">) {
  return <div className={cn("px-4 py-4", className)} {...props} />
}
